import React from 'react'
import { RangeSetup } from './d3-charts/range-chart'

class RangeChart extends React.Component {
  constructor (props) {
    super(props)

    // getinitialState
    this.state = {
      initData: props.data
    }
  }

  componentDidMount () {
    const _this = this
    const { label } = this.props
    // let data = this.state.initData;

    let settings = {
      el: 'chart' + label,
      margin: { top: 0, right: 0, bottom: 0, left: 0 }
    }

    let chart = new RangeSetup()
    chart.create(settings).then(function () {
      chart.update(_this.state.initData)
    })
  }

  render () {
    const { label } = this.props

    const divStyle = {
      // width:'800px',
      // height: '120px'
    }

    return (
      <div className="range-chart chart-wrapper">
        <div id={'chart' + label} style={divStyle} className="rangeChart" />
      </div>
    )
  }
}

export default RangeChart
